import styled from "styled-components";

export const SearchBarStyle = styled.div`
  max-width: 420px;
  width: 100%;
  margin-right:16px;

  .searchBar {
    height: 36px;
    border-radius: 8px;
    background: #242A34;
    border: 0.6px solid #FFFFFF33;
    color: ${(props) => props.theme.colors.primary} !important;
    width: 100%;
    font-size: 13px;
    font-weight: 400;

    &:hover {
      border-color: rgba(255, 255, 255, 0.4) !important;
    }

    &:focus {
      border-color: #1DB954 !important;
      box-shadow: 0 0 0 2px rgba(29, 185, 84, 0.2) !important;
    }
  }
  .searchBar input::placeholder {
    opacity:0.5;
  }
  @media only screen and (max-width: 600px) {
    .searchBar {
      font-size: 17px;
    }
  }

  .ant-input {
    background: transparent !important;
    padding:  0px;
    color: ${(props) => props.theme.colors.primary} !important;
  }
  .ant-input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${(props) => props.theme.colors.primary} !important;
    /* Firefox */
  }

  .ant-input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${(props) => props.theme.colors.primary} !important;
  }

  .ant-input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${(props) => props.theme.colors.primary} !important;
  }
  .ant-input-prefix {
    color: ${(props) => props.theme.colors.primary} !important;
    opacity:0.5;
    padding: 0px 8px 0px 5px;
    font-size: 14px;
  }
  .ant-input-suffix {
    color: ${(props) => props.theme.colors.primary} !important;
    padding: 0px 4px 0px 8px;
  }
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover{
    border-color: #FFFFFF33;
  }
`;
